import React from 'react';

// components
import Input from '../Inputs/Input/Input';
import Select from '../../components/Select/Select';

const ClientsFilter = ({ options, setValues }) => {
  const onValuesChange = (e, id) => {
    switch (id) {
      case 0:
        setValues((prev) => ({ ...prev, fio: e.target.value }));
        break;
      case 1:
        setValues((prev) => ({ ...prev, iin: e.target.value }));
        break;
      case 2:
        setValues((prev) => ({ ...prev, vip: e.target.value }));
        break;
      case 3:
        setValues((prev) => ({ ...prev, company: e.target.value }));
        break;
      case 4:
        setValues((prev) => ({ ...prev, role: e.target.value }));
        break;
      case 5:
        setValues((prev) => ({ ...prev, phone: e.target.value }));
        break;
      case 6:
        setValues((prev) => ({ ...prev, email: e.target.value }));
        break;
      case 7:
        setValues((prev) => ({ ...prev, broker: e.target.value }));
        break;
    }
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
        gap: '10px',
        marginTop: '20px',
        marginBottom: '10px',
      }}
    >
      {options.map((item, index) => (
        <React.Fragment key={index}>
          {index === 2 || index === 7 ? (
            <Select
              handleSetState={(val) => {

                onValuesChange({ target: { value: val.value } }, index);
              }}
              options={Object.values(item)[2]}
              title={Object.values(item)[0]}
              placeholder={Object.values(item)[1]}
            />
          ) : (
            <Input
              label={Object.values(item)[0]}
              placeholder={Object.values(item)[1]}
              onChange={(e) => {
                onValuesChange(e, index);
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ClientsFilter;
